/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';
import { lazy, Suspense } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

const LazyDebugPanelComponent = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/twg-microsite-debug-panel" */ '@atlassian/twg-microsite-experience/DebugPanel'
	).then((module) => ({
		default: module.DebugPanel,
	})),
);

/**
 * Renders `<DebugPanel>` only when the `twg_microsite_debug_panel` feature
 * gate is on. When the gate is off this returns `null` synchronously, which
 * means the lazy import is never evaluated and the corresponding JS chunk is
 * never requested by the browser.
 */
export const LazyDebugPanel = (): JSX.Element | null => {
	if (!fg('twg_microsite_debug_panel')) {
		return null;
	}

	return (
		<Suspense fallback={null}>
			<LazyDebugPanelComponent />
		</Suspense>
	);
};
